/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Stack from '@mui/material/Stack';
import { FullpageLoading, SeelEmail } from '@components';
import { useEffectOnce } from '@/hooks';
import { useTabs } from '@hooks/useTabs';
import {
  TextField, InputAdornment, Select, MenuItem,
} from '@mui/material';
import PageTitle from '@components/PageTitle';
import SearchIcon from '@mui/icons-material/Search';
// import { PRODUCT_TYPE } from '@constants';
import useConnectionContext from '@hooks/useConnectionContext';
import { TabPanel } from './TabPanel';
import { SESSION_KEY, SPECIAL_MERCHANTS } from './constants';

import classes from '../Transactions/index.module.css';
import './index.css';

// function a11yProps(index) {
//   return {
//     id: `vertical-tab-${index}`,
//     'aria-controls': `vertical-tabpanel-${index}`,
//   };
// }

export default function Page() {
  const [tabIndex, setTabIndex] = React.useState(0);
  const { tabs, isTabLoading } = useTabs();
  const [searchValue, setSearchValue] = React.useState('');
  const { store: { name, info } } = useConnectionContext();
  // const handleChange = (event, newTabIndex) => {
  //   setTabIndex(newTabIndex);
  // };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleChange = (event) => {
    setTabIndex(event.target.value);
  };
  const allTabs = [{ code: 'all', name: 'All products' }, ...tabs];
  // 从 policy detail 返回后保存状态
  useEffectOnce(() => {
    const initIndex = sessionStorage.getItem(SESSION_KEY.POLICY_LIST_TABINDEX);
    const policySearchValue = sessionStorage.getItem(SESSION_KEY.POLICY_SEARCHVALUE) || '';
    setSearchValue(policySearchValue === 'null' ? '' : policySearchValue);
    if (initIndex && typeof initIndex === 'string') {
      setTabIndex(Number(initIndex));
      sessionStorage.setItem(SESSION_KEY.POLICY_LIST_TABINDEX, '');
    }
  });

  return isTabLoading
    ? <FullpageLoading mask />
    : (
      <div className="container">
        <PageTitle title="Covers" />

        {/* placeholder-start */}
        {/* <Stack direction="column" style={{ visibility: 'hidden' }}>
          <Tabs
            orientation="vertical"
            variant="standard"
            sx={{
              visibility: 'hidden',
              width: '180px',
            }}
          />
        </Stack> */}
        {/* placeholder-end */}
        {
          // tabs?.length ? (
          //   <Stack direction="column" style={{ position: 'fixed' }}>
          //     <div className={classes.tabs_header}>Covers</div>
          //     <Tabs
          //       orientation="vertical"
          //       variant="standard"
          //       value={tabIndex}
          //       onChange={handleChange}
          //       aria-label="covers"
          //       sx={{
          //         width: '180px',
          //         '& .MuiTabs-indicator': {
          //           display: 'flex',
          //           justifyContent: 'center',
          //           backgroundColor: '#645AFF',
          //           height: '30px !important',
          //           width: '4px',

          //           left: 0,
          //           marginTop: '9px',
          //         },
          //       }}
          //     >
          //       {
          //         tabs.map((label, index) => (
          //           <Tab
          //             key={label.name}
          //             sx={{
          //               '&.MuiButtonBase-root': {
          //                 color: '#252525',
          //                 fontSize: '14px',
          //                 fontWeight: 500,
          //                 alignItems: 'flex-start',
          //               },
          //             }}
          //             style={{ textTransform: 'none' }}
          //             label={label.name}
          //             {...a11yProps(index)}
          //           />
          //         ))
          //       }
          //     </Tabs>
          //   </Stack>
          // ) : null
        }
        <Stack
          direction="column"
          sx={{
            width: '100%', alignItems: 'center', position: 'realative', zIndex: 11,
          }}
        >
          <div className={classes.tips}>
            Only data from the last 6 months is displayed.
            <SeelEmail text=" Contact us " />
            if you have any questions.
          </div>
          <div className="policy_search">
            {/* 目前只支持treet gently garmentory，等BE 把shopify 支持后再加上/ Customer Email / Customer Name */}
            <TextField
              id="fullWidth"
              fullWidth
              placeholder={`Order Number / Cover ID ${['Garmentory', 'Treet', 'Gently'].includes(name) ? '/ Customer Email / Customer Name' : ''}`}
              variant="outlined"
              value={searchValue}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
              }}
              sx={{
                '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused': {
                  border: '1px solid #645AFF',
                },
                '& .MuiInputBase-root.MuiOutlinedInput-root': {
                  height: '38PX',
                  border: '1px solid #C9CCCF',
                  // marginTop: '10px',
                },
                '&': {
                  '&& fieldset': {
                    border: 'none',
                  },
                },
              }}
            />
            {!SPECIAL_MERCHANTS.includes(info)
              && (
                <Select
                  labelId="simple-select-label"
                  id="tabs_select"
                  value={tabIndex}
                  defaultValue=""
                  label="Age"
                  onChange={handleChange}
                  sx={{
                    height: '38px',
                    border: '1px solid #C9CCCF',
                    '&.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused': {
                      border: '1px solid #645AFF',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      display: 'none',
                    },
                  }}
                >
                  {allTabs.map((tab, index) => <MenuItem value={index} key={tab.code}>{tab.name}</MenuItem>)}
                </Select>
              )}
          </div>
          {allTabs.map((tab, index) => (
            <TabPanel
              key={tab.code}
              tabIndex={tabIndex}
              tabs={allTabs}
              tab={tab}
              index={index}
              searchValue={searchValue}
            />
          ))}
        </Stack>
      </div>
    );
}
